module.exports = __webpack_public_path__ + "img/big-logo.5c76546b.png";